import { render } from "./sense.vue?vue&type=template&id=79851cce"
import script from "./sense.vue?vue&type=script&lang=js"
export * from "./sense.vue?vue&type=script&lang=js"

import "./sense.vue?vue&type=style&index=0&id=79851cce&lang=less"
script.render = render

export default script